<template>
	<core-page class="omapi-campaign-table">
		<h1 class="wp-heading-inline">Campaigns</h1>
		<core-button
			routerTo="templates"
			size="small"
			class="omapi-add-new"
		>Add New</core-button>
		<common-alerts v-if="connected" :alerts="alerts"/>
		<transition name="fade" mode="out-in">
			<campaigns-not-connected v-if="!connected && !isLoading"/>
			<campaigns-no-campaigns v-else-if="showNoCampaigns"/>
			<div v-else style="position: relative;">
				<campaigns-table-filters
					:isBulk="0 < bulk.length"
					@setAction="setAction"
					:actionKey="actionKey"
				/>
				<campaigns-table
					:campaigns="campaignsToShow"
					:isBulk="0 < bulk.length"
					@setAction="setAction"
					:actionKey="actionKey"
					:isRefreshing="isRefreshing || isLoading"
				/>
				<core-loading v-if="isLoading" style="position: absolute;top: 128px;opacity: .2;"/>
			</div>
		</transition>
	</core-page>
</template>

<script lang="js">
import get from 'lodash/get'
import { mapState, mapActions, mapGetters } from 'vuex'

export default  {
	inheritAttrs : false,
	data () {
		return {
			actionKey : 'none',
		}
	},
	/**
	 * Called when the route that renders this component is about to be
	 * navigated away from.
	 *
	 * @since  2.0.0
	 *
	 * @param  {Object}   to   New route.
	 * @param  {Object}   from Old route.
	 * @param  {Function} next Tells Vue Router we can proceed.
	 *
	 * @returns {void}
	 */
	beforeRouteLeave (to, from, next) {
		if ('campaigns' !== get(to, 'meta.parent') && 'campaigns' !== get(to, 'name')) {
			// If going away from campaigns, need to reset the page/search vars.
			this.updatePageVars()
		}
		next()
	},
	watch : {
		$route (to, from) {
			this.updatePageVars(to)

			this.refreshDashboard()
		},
	},
	mounted () {
		this.setPageVars({
			page   : this.$get('$route.params.campaignsPage', this.page),
			search : this.$get('$route.params.searchTerm', this.search),
		})

		if (!this.isLoading) {
			this.initRequests()
		}

		this.$bus.$on('fetchedMe', this.initRequests)
	},
	beforeDestroy () {
		this.$bus.$off('fetchedMe', this.initRequests)
	},
	computed : {
		...mapGetters([ 'connected', 'isFetched', 'shouldFetchUser' ]),
		...mapGetters('campaigns', [ 'campaignsWithSplits' ]),
		...mapState('campaigns', [ 'alerts', 'bulk', 'page', 'search', 'totalCampaignsCount' ]),
		isLoading () {
			return this.shouldFetchUser || this.$store.getters.isLoading('campaigns')
		},
		isRefreshing () {
			return this.$store.getters.isLoading('campaigns-refresh')
		},
		campaignsToShow () {
			if (this.connected) {
				return this.campaignsWithSplits
			}
			return []
		},
		hasCampaigns () {
			return 0 < this.totalCampaignsCount
		},
		showNoCampaigns () {
			return !this.hasCampaigns && !this.isLoading && this.isFetched('mainQuery')
		},
	},
	methods : {
		...mapActions('campaigns', [ 'setPageVars', 'refreshDashboard', 'fetchRulesetData' ]),
		initRequests () {
			this.refreshDashboard()
			this.fetchRulesetData()
		},
		setAction (key) {
			this.actionKey = key
		},
		updatePageVars (to = {}) {
			this.setPageVars({
				page   : get(to, 'params.campaignsPage', 1),
				search : get(to, 'params.searchTerm', ''),
			})
		},
	},
}
</script>

<style lang="scss">
	@import '../assets/scss/variables';
	@import '../assets/scss/pages/campaigns';
</style>
